/* eslint-disable */

import { DEALS_QUESTIONS } from '@zorba-shared/core/Constants/organization';
import { buildHomePageUrl } from '@zorba-shared/core/Services/urlBuilderService';
import { push } from 'connected-react-router';
import { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import {
  createOrganization,
  updateOrganizationDetails,
  updateUserDetails,
} from '../../../reducers/Auth/actions';
import { setModalState } from '../../../reducers/Modal/actions';

import {
  reportEvent,
  setUserProperties,
  setUserProperty,
} from '../../../services/analyticsService';
import { showErrorToast } from '../../../services/notificationsService';
import {
  buildOnboardingPageUrl,
  getRedirectUrl,
} from '../../../services/urlBuilderService';
import OnboardingStepView from './Components/OnboardingStepView';
import * as constants from './constants';
import './index.scss';
import {
  getAreasLongString,
  getStepParams,
  validateOnboarding,
} from './service';
import { USER_TYPE_BUYER } from '../../../constants/user';

const OnboardingWizard = (props) => {
  const { match, userDetails } = props;
  const isMarketplace = Boolean(
    userDetails?.defaultOrganization?.marketplacePartner,
  );
  const dispatch = useDispatch();
  const wizardSteps = constants.WIZARD_STEPS_BY_INTEREST[USER_TYPE_BUYER];
  const [validationObj, setValidationObj] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [params, setParams] = useState({
    ...constants.ONBOARDING_DEFAULT_PARAMS,
  });
  const [stepIndex, setStepIndex] = useState(0);

  const currentStepKey = wizardSteps[stepIndex];

  useEffect(() => {
    reportEvent('onboarding', 'start');
    const stepKey = match?.params?.stepKey;
    if (stepKey !== constants.ONBOARDING_STEP_BUYING_CRITERIA) {
      dispatch(push(buildOnboardingPageUrl()));
    }
  }, []);

  const navigatePage = (newStepIndex) => {
    const newStepKey = wizardSteps[newStepIndex];
    setStepIndex(stepIndex + 1);
    const newUrl = buildOnboardingPageUrl(newStepKey);
    reportEvent('onboarding', newStepKey);
    dispatch(push(newUrl));
  };

  /** Triggered when the user click Continue */
  const onContinue = () => {
    const { isValid, validationObj } = validateOnboarding(
      params,
      currentStepKey,
      isMarketplace,
    );
    setValidationObj(validationObj);
    if (!isValid)
      return showErrorToast(
        validationObj.customError || 'Fill required fields',
      );
    reportEvent('onboarding', `${currentStepKey}_next_click`);
    // IN CASE THIS IS THE LAST STEP
    if (stepIndex === wizardSteps.length - 1) {
      reportEvent('onboarding', 'success', { ...params });
      // this is the end
      const stageParams = getStepParams(currentStepKey, params);

      setUserProperties(userDetails);

      dispatch(
        updateUserDetails(
          {
            buyBoxList: stageParams.buyBoxList,
            isCompletedOnboarding: true,
            onboarding_mode: true,
            kind: 'buyer',
          },
          (updatedUser) => {
            setUserProperty('completed_onboarding', true, updatedUser._id);
            const numOfDealsValue = params.numOfDealsQuestion
              ? DEALS_QUESTIONS[params.numOfDealsQuestion]
                  .replace('+', '_more')
                  .replace('-', '_')
              : undefined;
            setUserProperty(
              'company',
              updatedUser.defaultOrganization.name,
              updatedUser?._id,
            );
            setUserProperty('num_of_deals', numOfDealsValue, updatedUser?._id);
            setUserProperty(
              'areas',
              getAreasLongString(params.buyBoxList),
              updatedUser?._id,
            );
            reportEvent('onboarding', 'completed', {
              num_of_deals: numOfDealsValue,
              areas: getAreasLongString(params.buyBoxList),
            });

            let redirectUrl = getRedirectUrl();

            if (!redirectUrl) {
              redirectUrl = buildHomePageUrl(false);
            }
            dispatch(push(redirectUrl));
          },
        ),
      );
      return;
    }

    navigatePage(stepIndex + 1);

    const currentStepParams = getStepParams(currentStepKey, params);
    dispatch(
      updateUserDetails({
        ...currentStepParams,
        onboarding_mode: true,
        organizationName: params.organizationName || 'Unnamed',
        entityName: params.entityName || '',
        additionalEntities: (params.additionalEntities || [])
          .map((entity) => entity.value)
          .filter(Boolean),
        kind: 'buyer',
      }),
    );
  };

  /** Triggered when the user click Back */
  const onBack = () => {
    navigatePage(stepIndex - 1);
  };
  const onChange = (key, value) => {
    if (key === '') {
      setParams({ ...params, ...value });
    } else {
      setParams({ ...params, [key]: value });
    }
  };

  return (
    <div className={`onboarding-wizard ${currentStepKey}`}>
      <OnboardingStepView
        {...props}
        validationObj={validationObj}
        currentStepKey={currentStepKey}
        onContinue={onContinue}
        onBack={onBack}
        params={params}
        onChange={onChange}
        setIsLoading={setIsLoading}
        isLoading={isLoading}
        wizardSteps={wizardSteps}
        stepIndex={stepIndex}
      />
    </div>
  );
};

const mapStateToProps = ({ AuthReducer }) => {
  const { userDetails, organization } = AuthReducer;

  return {
    userDetails,
    organization,
  };
};
const mapDispatchToProps = {
  push,
  setModalState,
  updateUserDetails,
  createOrganization,
  updateOrganizationDetails,
};

export default connect(mapStateToProps, mapDispatchToProps)(OnboardingWizard);
